import { Editor, IAllProps } from '@tinymce/tinymce-react';

interface Props extends Omit<IAllProps, 'tinymceScriptSrc' | 'api'> {
  children?: undefined;
}

export function TextEditor(props: Props) {
  const { init, ...editorProps } = props;
  return (
    // @ts-ignore NOTE: this error might be linked to react types version
    <Editor
      {...editorProps}
      tinymceScriptSrc={process.env.PUBLIC_URL + '/tinymce/tinymce.min.js'}
      init={{
        plugins: 'link lists',
        toolbar:
          'undo redo | styles | bold italic | ' +
          'alignleft aligncenter alignright alignjustify | ' +
          'bullist numlist outdent indent | ',
        statusbar: false,
        menubar: false,
        height: 300,
        ...init,
      }}
    />
  );
}
